<template>
  <div class="NewsList">
    <div class="_box"
         ref="cont">
      <div class="container">
        <div class="news-bar">
          <a :href="'/mobile'+item.link+'/'+item.id"
             :class="paindex == item.id ? 'on':''"
             v-for="(item,index) in newslist"
             @click="index = item.id"
             :key="index">{{item.title}}</a>
        </div>
      </div>
    </div>
    <router-view class="scolbox"
                 :style="{height:windowH+'px'}"></router-view>
  </div>
</template>

<script>
// import axiosApi from "../api/api.js";

export default {
  name: 'Home',
  components: {
  },
  data () {
    return {
      newslist: [
        {
          id: 0,
          link: '/shenqing',
          title: '大学申请服务',
        },
        {
          id: 1,
          link: '/zhusu',
          title: '住宿预定服务',
        },
        {
          id: 2,
          link: '/jieji',
          title: '机场接机服务',
        },
        {
          id: 3,
          link: '/visa',
          title: '签证服务',
        },
        {
          id: 4,
          link: '/jiaodui',
          title: '论文核对服务',
        },
        {
          id: 5,
          link: '/baoxian',
          title: '保险申请服务',
        },
        {
          id: 6,
          link: '/SIM-Card',
          title: '手机卡申请服务',
        },
      ],
      windowH: 800,
      paindex: 0,
      searchVal: ''
    }
  },

  mounted () {
    this.paindex = this.$route.params.id
    console.log(this.paindex)
    this.$nextTick(() => {
      this.windowH = window.screen.height - this.$refs.cont.offsetHeight - this.$store.state.navHeight - this.$store.state.botnavHeight
    })
    window.onresize = () => {
      return (() => {
        this.$nextTick(() => {
          this.windowH = window.screen.height - this.$refs.cont.offsetHeight - this.$store.state.navHeight - this.$store.state.botnavHeight
        })
      })()
    }

  },
  methods: {
    onSearch () { }
  },
}
</script>

<style lang="scss" scoped>
._box {
  box-shadow: 0px 0px 10px rgba($color: #000000, $alpha: 0.2);
}
.news-bar {
  display: flex;
  flex-wrap: wrap;
  padding: 10px 0;
  a {
    width: 33%;
    padding: 10px;
    &.on {
      color: #263e65;
      font-weight: bold;
    }
  }
}
.van-search {
  background-color: #f7f8fa;
}
.van-search__content {
  background-color: #fff;
  border-top-left-radius: 15px;
  border-bottom-left-radius: 15px;
}
.van-search--show-action {
  padding: 24px;
}
.van-search__action {
  background-color: #fff;
  border-left: 1px solid #f7f8fa;
  border-top-right-radius: 15px;
  border-bottom-right-radius: 15px;
}
</style>